import { render } from "./vue-draggable-resizable.vue?vue&type=template&id=6148bbb4"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__